export enum ItemTypes {
  ROSTER_SHIFT = 'roster_shift',
  TEMPLATE_SHIFT = 'template_shift',
  BREAK = 'break',
  TASK = 'task',
  REASSIGNED = 'reassigned'
}
